import { Button } from "@/components/ui/button";

const RANGES = [
  { value: 7, label: "7 days" },
  { value: 30, label: "30 days" },
  { value: 90, label: "90 days" },
];

export default function DateRange({ value, onChange }) {
  return (
    <div className="inline-flex items-center gap-1 rounded-full border border-border/60 bg-card p-1" data-testid="date-range">
      {RANGES.map((r) => (
        <button
          key={r.value}
          data-testid={`range-${r.value}`}
          onClick={() => onChange(r.value)}
          className={`rounded-full px-3.5 py-1.5 text-xs font-semibold transition-colors sm:text-sm ${
            value === r.value ? "bg-brand-primary text-brand-primary-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"
          }`}
        >
          {r.label}
        </button>
      ))}
    </div>
  );
}
